import { CustomerLookupResponseAccount } from 'packages/tackle-api/src/co-sell-msft/customerLookup';
import {
  FORM_STEP_CONTAINER_WIDTH,
  FORM_STEP_CONTAINER_MIN_WIDTH,
  CustomerSearchFormStep,
} from '../../constants';
import { useTheme, Typography } from 'ui';
import { TYPOGRAPHY_STYLES } from '../../constants';
import { getAddressFromAccountDetails } from '../../helpers';
import { CustomerAccountDetailsType } from '../../customerAccountTransformSchema';

// COMPONENTS
import BackLink from '../../../components/BackLink/BackLink';
import { Box, makeStyles } from 'vendor/material';
import { Tag } from '@tackle-io/platform-ui';
import LinkedAccountItem from '../LinkedAccountItem/LinkedAccountItem';

const useStyles = makeStyles((theme) => ({
  linkedAccountsTag: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(12),
    letterSpacing: theme.typography.pxToRem(0.3),
    '& span': {
      textAlign: 'center',
    },
    padding: `7px 8px`,
    borderRadius: '4px',
    background: '#EBECF0',
    color: '#505F79',
  },
}));

export default function LinkedAccountsList({
  selectedAccount,
  setSelectedAccount,
  setFormStep,
  activeTypeTabIndex,
  handleAddToForm,
}: {
  selectedAccount: CustomerLookupResponseAccount;
  setSelectedAccount: (account: CustomerLookupResponseAccount) => void;
  setFormStep: (step: CustomerSearchFormStep) => void;
  activeTypeTabIndex: number;
  handleAddToForm: (customerDetails: CustomerAccountDetailsType) => void;
}) {
  const theme = useTheme();
  const classes = useStyles();
  const accountDetails = selectedAccount?.customerAccountDetails;
  const childAccounts = selectedAccount?.childAccounts;
  const childAccountsCount = childAccounts?.length || 0;

  const minWidth = theme.breakpoints.up('sm')
    ? FORM_STEP_CONTAINER_MIN_WIDTH
    : 'auto';

  const TITLE_BY_ACTIVE_TAB = {
    0: 'Microsoft managed accounts',
    1: 'Microsoft unmanaged accounts',
    2: 'Other accounts',
  };

  return (
    <Box minWidth={minWidth} width={FORM_STEP_CONTAINER_WIDTH}>
      <BackLink
        text={'Back'}
        onClick={() => {
          setSelectedAccount(null);
          setFormStep(CustomerSearchFormStep.ACCOUNTS_LIST);
        }}
      />

      <Box>
        <Typography
          style={{ ...TYPOGRAPHY_STYLES, fontSize: 16, fontWeight: 600 }}
          mb={2}
        >
          {TITLE_BY_ACTIVE_TAB[activeTypeTabIndex]}
        </Typography>

        <Typography
          style={{ ...TYPOGRAPHY_STYLES, fontSize: 12, fontWeight: 700 }}
          mb={1}
        >
          {accountDetails?.name}
        </Typography>

        <Typography
          style={{
            ...TYPOGRAPHY_STYLES,
            fontSize: '12px',
            fontWeight: 400,
          }}
          mb={1}
        >
          {getAddressFromAccountDetails({ accountDetails })}
        </Typography>

        <Typography
          style={{
            ...TYPOGRAPHY_STYLES,
            fontSize: '12px',
            fontWeight: 400,
          }}
          mb={1}
        >
          <strong>Microsoft ID: </strong>
          {accountDetails?.msp_accountnumber}
        </Typography>

        <Tag className={classes.linkedAccountsTag}>
          {childAccountsCount} linked accounts
        </Tag>
      </Box>
      {childAccountsCount > 0 && (
        <Box mt={2}>
          {childAccounts?.map((account, index) => {
            return (
              <LinkedAccountItem
                key={`${account?.customerAccountDetails?.msp_accountnumber}-${index}`}
                account={account}
                onSelect={handleAddToForm}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
}
